import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import File from "./fya/File";
import { FileCard } from "./fya/FileCard";
// import { removeFile } from "api/services/storage";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { useConfirm } from "context/ConfirmDialog";
import { useParams } from 'react-router-dom';
import { manualAttachmentsDelete } from "api/services/gstr/gstr";

const AttachmentDisplay = ({ data }) => {
  const queryClient = useQueryClient();
  const confirm = useConfirm();
  const params = useParams();

  const { mutate } = useMutation(manualAttachmentsDelete, {
    onSuccess: () => {
      snack.success("Attachment Deleted");
      queryClient.invalidateQueries("e-proceeding-notice");
      queryClient.invalidateQueries("order-notice-full-view");
      queryClient.invalidateQueries("additional-notice-full-view");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleDelete = (item) => {
    confirm({
      msg: "Are you sure you want to delete this item?",
      action: () => {
        mutate({ id: item.uid, gstrId: params.gstrid });
      },
    });
  };
  const handleClickManual = (data) => {
    window.open(
      data?.storageSystem === "AMAZON" || data?.storageSystem === "BHARATHCLOUD"
        ? data?.fileUrl
        : data?.downloadUrl
    );
  };

  return (
    <>
      {data?.length > 0 && (
        <>
          <Box padding={1} sx={{ backgroundColor: "#F6F6F6" }}>
            <Typography variant="subtitle2">Manual Attachmentss</Typography>
          </Box>

          <Grid container spacing={1}>
            {data &&
              data?.map((detail: any, index: number) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  {/* <File data={detail} /> */}
                  <FileCard
                    title={detail?.name}
                    value={detail?.name}
                    file={detail.webUrl ?? detail?.fileUrl}
                    onClose={() => handleDelete(detail)}
                  />
                </Grid>
                //   <Box display="flex" textAlign="left" alignItems="center">
                //     <Typography style={{ padding: "3px", margin: "2px" }}>
                //       {index + 1}.
                //     </Typography>
                //     <div
                //       key={index}
                //       style={{
                //         cursor: "pointer",
                //         padding: "3px",
                //         margin: "2px",
                //         border: "1px solid #ccc",
                //         borderRadius: "5px",
                //         color: "blue",
                //       }}
                //       onClick={() => handleClickManual(detail)}
                //     >
                //       {detail?.name}
                //     </div>
                //   </Box>
              ))}
          </Grid>
        </>
      )}
    </>
  );
};

export default AttachmentDisplay;
